import React from 'react'
import classnames from 'classnames'
import { i18n } from '../../validator'
import Modal from '../modal'
import logout from '../../admin/actions/logout'
import Button from '../../front/components/shared/sn-button'
import Input from '../../front/components/shared/sn-input'
import Configurator from '../../configurator'

@i18n()
export default class FullNameMissing extends Configurator {
    state = {
        name: null,
        surname: null,
        busy: false,
        errorMessage: null,
    }

    /**
     * Updates api name and surname
     * @param {string} name
     * @param {string} surname
     * @return {Promise}
     */
    addApiFullName = (name, surname) => (
        this.axios
            .patch(`${window.APP_CONFIG.REACT_APP_API_URL}api/users/me/update`, {
                data: {
                    name: name,
                    surname: surname,
                },
            })
            .then(() => window.location.reload())
            .catch(error => {
                if (error?.data?.errors) {
                    const validationErrors = Object.values(error.data.errors)
                        .reduce((acc, cval) => `${acc} ${cval}\n`)

                    this.setState({
                        errorMessage: validationErrors,
                    })
                }

            })
    )

    /**
     * Handles input change
     * @param {string} key
     * @param {string} value
     */
    handleChange = (key, value) => {
        this.setState({ [key]: value })
    }

    /**
     * handle modal form submit
     * @param  {Object} e submit event
     * @return {Promise}
     */
    handleSubmit = e => {
        e.preventDefault()

        const {
            name,
            surname,
        } = this.state

        const { t } = this.props

        this.setState({ busy: true })

        this.addApiFullName(name, surname)
            .then(() => this.setState({ busy: false }))
            .catch(() => window.swalert(t('serverErrorMessage')))
    }

    render = () => {
        const { t } = this.props

        const {
            name,
            surname,
            errorMessage,
            busy,
        } = this.state

        return (
            <Modal
                handleHideModal={() => logout()}
                description={t('userFullnameMissing')}
                content={() =>
                    <div className="p-4">
                        <h6 className="m-0">
                            {t('userFullnameMissingDescription')}
                        </h6>
                        <form onSubmit={this.handleSubmit}>
                            <div className="modal-body">
                                <Input
                                    type="text"
                                    label="Jméno"
                                    placeholder="Jméno"
                                    value={name || ''}
                                    onChange={event => this.handleChange('name', event.target.value)}
                                    className="form-control form-control-sm"
                                    required
                                    maxLength="50"
                                />
                                <Input
                                    type="text"
                                    label="Příjmení"
                                    placeholder="Příjmení"
                                    value={surname || ''}
                                    onChange={event => this.handleChange('surname', event.target.value)}
                                    className="form-control form-control-sm"
                                    required
                                    maxLength="50"
                                />
                                <span className="font-weight-bold text-dark">{errorMessage}</span>
                            </div>
                            <div className="modal-footer">
                                <Button
                                    submit
                                    className={classnames({
                                        'btn btn-color-brand': true,
                                        'btn-loading btn-disabled': busy,
                                    })}
                                >
                                    Pokračovat
                                </Button>
                            </div>
                        </form>
                    </div>
                }
                keyboard={false}
                backdrop="static"
            />
        )
    }
}
